exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VideoBg{position:relative;background-size:cover;background-position:50%;overflow:hidden}.VideoBg video{position:absolute;top:50%;left:50%;visibility:hidden;transform:translate(-50%,-50%)}.VideoBg__content{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-512447cc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-videobg/src/VideoBackground.vue
// module id = 28
// module chunks = 0